import { Bar } from 'react-chartjs-2'

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Tooltip
} from 'chart.js'

import { BAR_CHART_COLORS } from './chartColors'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const chartOpts: ChartOptions<'bar'> = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      labels: {
        color: '#34414F',
        font: { size: 12 },
        boxWidth: 12,
        boxHeight: 12,
        padding: 8,
        usePointStyle: false
      }
    },
    tooltip: {
      backgroundColor: 'rgba(2, 6, 23, 0.95)',
      titleFont: { family: "'JetBrains Mono', monospace", size: 11, weight: 'bold' },
      bodyFont: { family: "'JetBrains Mono', monospace", size: 11 },
      padding: 8,
      cornerRadius: 4,
      borderColor: 'rgba(6,182,212,0.2)',
      borderWidth: 1,
      displayColors: true
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: '#E4E8EE' },
      ticks: { font: { size: 10 }, color: '#34414F', padding: 6, precision: 0 }
    },
    y: {
      grid: { display: false },
      border: { display: false },
      ticks: { font: { size: 10 }, color: '#34414F', autoSkip: false }
    }
  }
}

interface Props {
  labels: string[]
  items: {
    title: string
    values: (string | number)[]
    // 系列色を指定する（自社/競合など、意味で色が決まる場合に使う）
    color?: string
  }[]
}

// 横棒グラフ。項目名が長く、縦棒だと軸ラベルが読みにくい比較に使う
const HorizontalBarChart = ({ labels, items }: Props) => (
  <Bar
    data={{
      labels,
      datasets: items.map((item, i) => ({
        label: item.title,
        data: item.values,
        backgroundColor: item.color ?? BAR_CHART_COLORS[i % BAR_CHART_COLORS.length],
        borderRadius: 2,
        borderSkipped: false
      }))
    }}
    options={chartOpts}
  />
)

export default HorizontalBarChart
